<script>
    import FormGroup from '~/components/form/components/form_group';
    import ImageCrop from '~/components/image_crop/components/image_crop';

    export default {
        name: "image-crop-wrap",

        components: {
            FormGroup,
            ImageCrop
        },

        data() {
            return {
                label: '',
                uploadError: {
                    'valid': true,
                    'validationState': ''
                },
                modalVisible: false,
                cropped: null
            }
        },

        props: {
            inputName: {
                type: String,
                required: true
            },

            labelName: {
                type: String,
                default: null
            },

            description: {
                type: String,
                default: null
            },

            maxSizeMb: {
                type: Number,
                default: 1,
            },

            defaultImage: {
                type: String
            },

            allowCrop: {
                type: Boolean,
                default: true
            },

            cropDialogTitle: {
                type: String,
                default: 'Image Cropper'
            },

            useCroppie: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            // Defaults are built here rather than in `props` so the stated limit always
            // tracks maxSizeMb; a hardcoded default would drift once a caller raises it.
            labelText() {
                return this.labelName !== null
                    ? this.labelName
                    : `Profile Photo: Recommended file size for images is 50kb (max: ${this.maxSizeMb}MB)`;
            },

            descriptionText() {
                return this.description !== null
                    ? this.description
                    : `Allowed types are jpg, png, gif (max ${this.maxSizeMb}MB)`;
            },

            croppedOrDefault() {
                if(this.defaultImage){
                    return this.cropped = this.defaultImage;
                } else {
                    return this.cropped;
                }
            }
        },

        methods: {
            checkFileSize(file) {
                // Decimal MB (10^6), not MiB, so the limit matches the size the OS file
                // browser reports to the user -- a "5.2 MB" file in Finder is rejected by a
                // 5MB limit rather than silently passing as 4.96 MiB.
                const withinLimit = file.size <= this.maxSizeMb * 1000 * 1000;
                if (!withinLimit) {
                    this.uploadError.valid = false;
                    this.uploadError.validationState = 'error';
                    this.modalVisible = false;
                }else{
                    this.uploadError.valid = true;
                    this.uploadError.validationState = '';
                    this.modalVisible = true;
                }
            },

            handleImageSave(val) {
                this.$emit('image-saved', val);
            },

            openModal() {
                this.modalVisible = true;
            }
        }
    };
</script>

<template>
    <div>
        <div class="image-crop">
            <form-group
                :label="labelText"
                :description="descriptionText"
                :hasError="!uploadError.valid"
                :validation-state="uploadError.validationState"
            >
                <img v-if="croppedOrDefault" :src="cropped" class="cropped-image" @click="openModal">
                <input type="hidden" :name="inputName" class="form-control" :value="cropped"/>
                <image-crop
                    v-model="cropped"
                    :allow-crop="allowCrop"
                    :use-croppie="useCroppie"
                    :crop-dialog-title="cropDialogTitle"
                    :cropModalVisible.sync="modalVisible"
                    :close-on-click-modal="false"
                    :default-image="cropped"
                    :show-close="false"
                    @change="checkFileSize"
                    @input="handleImageSave"
                >
                </image-crop>
            </form-group>
        </div>
    </div>
</template>